import React from "react";
import { ImageProvider } from "../../../utils/image-provider";
import SubHeading from "../../../components/common/heading/SubHeading";
const StayInformed = ({ data }) => {
  return (
    <div id="stayinformed-section" className="container mx-auto px-4 py-8">
      {data?.heading && (
        <div className="flex justify-center lg:pb-[1.5vw] pb-[3vw]">
          <div className="lg:w-fit text-center border-b-[0.15vw] border-[#F77D0D]">
            {/* <SubHeading
              text={data?.heading}
              textColor={ "#002C62"}
            /> */}
            <h2
              className="font-redhatMedium lg:text-[2.3vw] md:text-[5vw] text-[5.5vw] text-center"
              style={{
                color: '#002C62',
              }}>
              {data?.heading}
            </h2>
          </div>
        </div>
      )}

      {/* <div className="mb-[3vw] p-[4vw] xl:p-[2vw] bg-gray-200 rounded-md">
        <h4 className="text-center mb-[4vw] xl:mb-[2vw] text-[4vw] xl:text-[1.5vw] font-redhatBold text-primary">
          Current Travel Advisory
        </h4>
        <div className="flex flex-col-reverse xl:flex-row gap-[4vw]">
          <div className="w-full xl:w-1/2 p-4 flex items-center jtext-center text-[4vw] xl:text-[1.2vw] leading-[7vw] xl:leading-[2.5vw]">
            <p className="font-redhatRegular xl:text-left text-center text-primary">
              All flight operations from Terminal 2 has been shifted to Terminal
              1 till further notice. For flight information, kindly contact the
              concerned airline.
            </p>
          </div>
          <div className="w-full xl:w-[40%] h-[30vh] xl:h-[45vh] overflow-hidden">
            <img
              src="https://d31szslsujr0rm.cloudfront.net/Chat_GPT_Image_Aug_29_2025_06_26_03_PM_313880adfc.jpg"
              alt=""
              className="w-full h-full object-fill rounded-md"
            />
          </div>
        </div>
      </div> */}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {data?.cards?.map((card, idx) => (
          <div key={idx} className="bg-white rounded-xl p-4 text-center">
            <ImageProvider
              className="mt-2 mx-auto"
              Image={card?.card_image}
              alt={card?.card_image?.alternativeText || "Stay info image"}
              tailwindStyle={
                "w-[20.56vh] h-100 sm:w-[25.56vh] sm:h-[19.56vh] md:h-[20.44vh] md:w-[30.44vh] object-contain"
              }
            />

            {card?.description?.data?.description &&
              (() => {
                const text = card.description.data.description;
                const match = text.match(/\[(.*?)\]\((.*?)\)/);

                if (!match) {
                  return (
                    <h2
                      className="md:text-[1.2vw] text-[3.29vw] font-redhatMedium mt-5"
                      style={{ color: card?.heading_color }}
                    >
                      {text}
                    </h2>
                  );
                }

                const [fullMatch, linkText] = match;
                const [before, after] = text.split(fullMatch);

                return (
                  <h2
                    className="md:text-[1.2vw] text-[3.29vw] font-redhatMedium mt-5"
                    style={{ color: card?.heading_color }}
                  >
                    {before}
                    <a
                      href={`https://${linkText}`}
                      className="underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {linkText}
                    </a>
                    {after}
                  </h2>
                );
              })()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StayInformed;
